import React, { useState } from "react";
// Components
import SuccessPopup from "../../success-popup/successPopup";
import CreateZpin from "../create-zpin/createZpin";
import OtpVerificationPopUp from "../otp-verification-pop-up/otpVerificationPopUp";

// Functions
import { callApi } from "../../../api/fetch";
import { getCurrentUserId } from "../../../utils/authSession";
import { OTP_PURPOSE } from "../../../utils/otpApi";
import { zpinFlowError } from "../../../constants/zpin";

function ZpinCreateOrUpdate({
  forOtp,
  onCancel,
  resendOtp,
  onVerifyOtp,
  afterSuccessfulCreation,
  relayId,
}: any) {
  const [createZpin, setCreateZpin] = useState(!forOtp);
  const [error, setError] = useState("");
  const [zpin, setZpin] = useState("");
  const forOtpFlow = forOtp;
  const [otpForZpin, setOtpForZpin] = useState(forOtp);
  const [onSuccess, setOnSuccess] = useState(false);

  function showZpinError(error: any, setInvalidOtpError: (message?: string) => void) {
    const mapped = zpinFlowError(error?.message);
    if (mapped.isOtpError) {
      setInvalidOtpError(mapped.text);
      return;
    }
    setError(mapped.text);
  }

  // Create New / first-time setup always POST a new row. Previous ZPINs
  // (including expired 1111 after a change to 1234) are expired by the API.
  async function handleZpinAuthCreate(
    otp_entered: string,
    setInvalidOtpError: any
  ) {
    try {
      await callApi("/zpins", {
        method: "POST",
        data: {
          user_pid: getCurrentUserId(),
          zpin,
          relay_id: relayId,
          otp: otp_entered,
        },
      });
      setOtpForZpin(false);
      setOnSuccess(true);
      setTimeout(() => {
        setOnSuccess(false);
        afterSuccessfulCreation();
      }, 3000);
      setError("");
    } catch (error: any) {
      showZpinError(error, setInvalidOtpError);
    }
  }

  async function getZpin(zpin_entered: string) {
    setZpin(zpin_entered);
    setCreateZpin(false);
    setOtpForZpin(true);
    await resendOtp(OTP_PURPOSE.MANAGING_ZPIN);
  }

  function getOtp(zpin: string, otp_entered: string, setInvalidOtpError: any) {
    if (forOtpFlow) {
      onVerifyOtp(zpin, otp_entered, setInvalidOtpError);
      return;
    }
    handleZpinAuthCreate(otp_entered, setInvalidOtpError);
  }

  return (
    <>
      {createZpin && (
        <CreateZpin
          onCancel={onCancel}
          getZpin={getZpin}
          resendOtp={resendOtp}
        />
      )}
      {otpForZpin && (
        <OtpVerificationPopUp
          onCancel={() => onCancel()}
          getOtp={getOtp}
          resendOtp={resendOtp}
          forZpin={true}
          error={error}
          setError={(value: any) => setError(value)}
        />
      )}
      {onSuccess && (
        <SuccessPopup
          message="ZPIN successfully created"
        />
      )}
    </>
  );
}

export default ZpinCreateOrUpdate;
